export default __webpack_public_path__ + "static/media/flatmatch.79accd2f.gif";